import React, { useState, useEffect, useMemo } from "react";
import gql from "graphql-tag";
import { useQuery } from "components/graphql";
import FormTextField from "components/form/form-textfield";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import Card from "components/card";
import { PageSection, PageHeaderBar } from "components/page";
import FormCheckbox from "components/form/form-checkbox";
import { OcurrencesSourceTypesSelect, ocurrencesSourceTypesQuery } from "components/select";

const MatchPointConfigForm = ({ intl, values, handleChange, eventToEdit = {}, eventCopy }) => {
  const [showForm, setShowForm] = useState(false);

  const query =  useMemo(
      () =>  ({
      query: gql`
        ${ocurrencesSourceTypesQuery}
      `,
      skip: !values.contractId || !values.typeId,
      variables: { contractId: values?.contractId || eventCopy?.contractId , eventTypeId: values?.typeId || eventCopy?.typeId },
    }),
    eventCopy ? [eventCopy?.contractId, eventCopy?.typeId] : [values?.contractId, values?.typeId],
  ) 
  const { data, loading, error } = useQuery(query);

  useEffect(
    () => {
      if (!loading && !error) {
        setShowForm(data.ocurrencesSourceTypes && data.ocurrencesSourceTypes.total);
      }
      if(eventCopy){
        setShowForm(true);
      }
    },
    [data, data.ocurrencesSourceTypes, error, loading],
  );

  return !showForm ? null : (
    <>
      <PageHeaderBar subtitle title="event.sportEventData.matchPointConfig" />
      <PageSection hideBackground>
        <DataGrid>
          <Card>
            <DataGridItem>
              <OcurrencesSourceTypesSelect
                id="matchPointConfig.ocurrencesSource"
                name="matchPointConfig.ocurrencesSource"
                emptyValueText={intl.formatMessage({ id: "common.none" })}
                emptyValue={null}
                isInsideForm
                label={intl.formatMessage({ id: "event.matchPointConfig.ocurrencesSource" })}
                onChange={handleChange}
                value={values?.matchPointConfig ? values?.matchPointConfig.ocurrencesSource : ""}
                variables={{
                  contractId: values?.contractId || eventToEdit?.contractId || eventCopy?.contractId,
                  eventTypeId: values?.typeId || eventToEdit?.typeId || eventCopy?.typeId,
                }}
              />
            </DataGridItem>
            <DataGridItem>
              <FormCheckbox
                id="matchPointConfig.ocurrencesVisible"
                name="matchPointConfig.ocurrencesVisible"
                value="matchPointConfig.ocurrencesVisible"
                checked={values?.matchPointConfig ? values?.matchPointConfig.ocurrencesVisible : false}
                onChange={handleChange}
                label={intl.formatMessage({ id: "event.matchPointConfig.ocurrencesVisible" })}
              />
            </DataGridItem>
            <DataGridItem big>
              <FormTextField
                type="text"
                id="matchPointConfig.ocurrencesSourceId"
                name="matchPointConfig.ocurrencesSourceId"
                value={values?.matchPointConfig ? values?.matchPointConfig.ocurrencesSourceId : ""}
                onChange={handleChange}
                label={intl.formatMessage({ id: "event.matchPointConfig.ocurrencesSourceId" })}
              />
            </DataGridItem>
          </Card>
        </DataGrid>
      </PageSection>
    </>
  );
};

MatchPointConfigForm.propTypes = {
  /**
   * Valores del formulario
   */
  values: PropTypes.object,
  /**
   * Otros datos del evento a editar que no se envían en el form
   */
  eventToEdit: PropTypes.object,
  /**
   * Callback que se dispara con el cambio del input
   */
  handleChange: PropTypes.func,
};

export default injectIntl(MatchPointConfigForm);
